import "../charts.css";

import React from "react";
import { getUserDisplayName } from "src/Utils/Common";
import ReactApexChart from "react-apexcharts";


// import { setCurrentChartType } from "src/Redux/chartSlice/chartSlice";

export const BarChartPinned = ({ title, dataValues }) => {
  const categories = [getUserDisplayName(), "Market"].map((cat) =>
    cat.trim().split(/\s+/)
  );

  const options = {
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      title: {
        text: title,   // Your chart title
        align: "center",                // Options: 'left', 'center', 'right'
        margin: 10,
        offsetY: 0,
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          color: "#263238"
        }
      },
      colors: ["#21A0FF","#08306B"], // Ensuring the colors match legend
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return `${val.toFixed(2)}`; // Format labels as percentages
        },
        offsetY: -8, // Moves the label above the bars
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          colors: ["#ffffffff"],
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "50%", // Increased to create more space between bars
          barHeight: "100%",
          endingShape: "rounded",
          borderRadius: 4,
          distributed: true, // Keep same category bars together
          colors: {
            backgroundBarColors: ["#E0E0E0"], // Light grey background for unselected bars
            backgroundBarOpacity: 0.2,
          },
        },
      },
      grid: {
        show: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      xaxis: {
        categories: categories,
        labels: {
          show: true,
          fontSize: "10px",
          fontWeight: 600,
          trim: false,
          hideOverlappingLabels: false,
        },
        tooltip: {
          enabled: true,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
        min: 0,
        
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val) => `${val.toFixed(2)}%`,
        },
        theme: "dark",
      },
      legend: {
        position: "bottom",
        offsetX: 5,
        offsetY: 5,
        markers: {
          radius: 5, // Rounded markers
        },
        fontSize: "12px",
        fontWeight: 600,
      },
    };

  return (
    <ReactApexChart
        options={options}
        series={dataValues}
        type="bar"
        width={200}
        height={200}
    />
            
  );
};
